import { apiInstance } from 'api/utils';
import { ForecastReturnType } from 'utils/forecastReturnType';

export default {
  downloadReturnForecastsConfig: () => {
    return apiInstance.request({
      method: 'GET',
      url: '/meta/download-return-forecasts-config/'
    });
  },
  updateReturnForecastsConfig: (data: ForecastReturnType) => {
    return apiInstance.request({
      method: 'POST',
      url: '/meta/return-forecasts-config/',
      data
    });
  },
  updateEnableForecastsConfig: (data: boolean) => {
    return apiInstance.request({
      method: 'PUT',
      url: '/meta/return-forecasts-config/',
      data
    });
  },
  resetReturnForecastsConfig: () => {
    return apiInstance.request({
      method: 'DELETE',
      url: '/meta/return-forecasts-config/'
    });
  },
  updateMorningstarReturnForecastsConfig: (data: any) => {
    return apiInstance.request({
      method: 'POST',
      url: '/meta/morningstar-return-forecasts-config/',
      data
    });
  },
  resetMorningstarReturnForecastsConfig: () => {
    return apiInstance.request({
      method: 'DELETE',
      url: '/meta/morningstar-return-forecasts-config/'
    });
  }
};
